// Call this to register our module to main application
const moduleName = 'storefront.account';
const { storefrontAppDependencies } = window;

if (angular.isArray(storefrontAppDependencies)) {
    storefrontAppDependencies.push(moduleName);
}

angular.module(moduleName, ['ngResource', 'ngComponentRouter', 'storefrontApp'])
    .config(['$translateProvider', function ($translateProvider) {
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        // eslint-disable-next-line angular/window-service
        $translateProvider.useUrlLoader(window.BASE_URL + 'themes/localization.json');
        $translateProvider.preferredLanguage('en');
    }])

    .run(['$templateCache', function ($templateCache) {
        // cache application level templates
        $templateCache.put(
            'pagerTemplate.html',
            `<uib-pagination boundary-links="true"
                             max-size="$ctrl.pageSettings.numPages"
                             items-per-page="$ctrl.pageSettings.itemsPerPageCount"
                             total-items="$ctrl.pageSettings.totalItems"
                             ng-model="$ctrl.pageSettings.currentPage"
                             ng-change="$ctrl.pageSettings.pageChanged()"
                             class="pagination-sm"
                             previous-text="&lsaquo;"
                             next-text="&rsaquo;"
                             first-text="&laquo;"
                             last-text="&raquo;"></uib-pagination>`,
        );
    }])

    .value('$routerRootComponent', 'vcAccountManager')

    .component('vcAccountManager', {
        templateUrl: 'account-manager.tpl',
        bindings: {
            baseUrl: '<',
            customer: '<',
        },
        $routeConfig: [
            {
                path: '/profile',
                name: 'Profile',
                component: 'vcAccountProfileUpdate',
                useAsDefault: true,
            },
            {
                path: '/addresses',
                name: 'Addresses',
                component: 'vcAccountAddresses',
            },
            {
                path: '/payment',
                name: 'Payment',
                component: 'vcAccountPayment',
            },
            {
                path: '/orders/...',
                name: 'Orders',
                component: 'vcAccountOrders',
            },
            {
                path: '/wishlist',
                name: 'Wishlist',
                component: 'vcAccountWishlist',
            },
            // { path: '/return', name: 'Return', component: 'vcAccountReturn' },
        ],
        controller: [
            'storefront.accountApi',
            'storefrontApp.mainContext',
            'loadingIndicatorService',
            '$rootRouter',
            '$document',
            'focusService',
            function (
                accountApi,
                mainContext,
                loader,
                $rootRouter,
                $document,
                focusService,
            ) {
                const $ctrl = this;

                $ctrl.loader = loader;

                // WCAG 2.4.3: the account section swaps the active view in <ng-outlet>
                // on route change (Profile/Addresses/Payment/Orders/Wishlist) without
                // moving focus, stranding keyboard/SR users on the now-removed view.
                // Move focus to the outlet region only after a USER-initiated route
                // change: arm on a cabinet-menu activation (click or keyboard Enter on
                // an ng-link item), then the next router navigation moves focus and
                // disarms. The initial page-load route resolution is never armed, so it
                // never steals focus — important because this surface caused the
                // 2026-04-15 rollback, and the router's load-time emit count/urls are
                // not stable enough to skip by comparison.
                let focusOnNextNavigation = false;
                $document.on('click', function (event) {
                    if (event.target.closest && event.target.closest('.cabinet-menu__item[ng-link]')) {
                        focusOnNextNavigation = true;
                    }
                });
                $rootRouter.subscribe(function () {
                    if (focusOnNextNavigation) {
                        focusOnNextNavigation = false;
                        focusService.focusRegion('account-view');
                    }
                });

                $ctrl.getQuotes = function (pageNumber, pageSize, sortInfos, callback) {
                    return loader.wrapLoading(() => accountApi.searchQuotes({
                        pageNumber,
                        pageSize,
                    }, callback).$promise);
                };

                $ctrl.updateProfile = function (updateRequest) {
                    return loader
                        .wrapLoading(() => accountApi.updateAccount(updateRequest, mainContext.getCustomer).$promise);
                };

                $ctrl.updateAddresses = function (data) {
                    return loader.wrapLoading(() => accountApi.updateAddresses(data, mainContext.getCustomer).$promise);
                };

                $ctrl.availCountries = accountApi.getCountries();

                $ctrl.getCountryRegions = function (country) {
                    return accountApi.getCountryRegions(country).$promise;
                };

                $ctrl.changePassword = function (changePasswordData) {
                    return loader.wrapLoading(() => accountApi.changePassword(changePasswordData).$promise);
                };
            }],
    })

    .service('confirmService', ['$q', '$window', function ($q, $window) {
        this.confirm = function (message) {
            return $q.when($window.confirm(message || 'Is it OK?'));
        };
    }])

    .factory('loadingIndicatorService', () => {
        const retVal = {
            isLoading: false,
            wrapLoading(func) {
                retVal.isLoading = true;
                return func()
                    .then((result) => {
                        retVal.isLoading = false;
                        return result;
                    },
                    () => {
                        retVal.isLoading = false;
                    });
            },
        };

        return retVal;
    });
